import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import LoadingContent from '../../component/loading/LoadingContent';
import styled from "styled-components";

import AuthService from '../../service/Auth'
import ServiceMap from '../../service/Map'
import ServiceListAllStation from '../../service/Mgt-station';
import ServiceListAllSensor from '../../service/Mgt-sensor';
import ServiceSensorDataAlarm from '../../service/Mgt-sensor-data-alarm';

import Map from "../../component/map/Index";
import actions from "../../redux/actions";
import SummaryStation from "../../component/card/SummaryStation";
import SummarySensor from "../../component/card/SummarySensor";
import TableListAllStation from "./TableListAllStation";
import TableListAllSensor from "./TableListAllSensor";
import TableListAlarm from "./TableListAlarm";


const Section = styled.section`
    height: 100%;
    
    & > .container{ 
        height: 100%;

        & > .row{ 
            margin-top: 10px; 
            display: flex;
            justify-content: space-between;
            width: 100%;

            .map{ 
                height: 650px; 
                width: 100%;
            }

            .table-stations,
            .table-sensors{
                margin-top: 15px;
                width: 49.5%;
            }
            
            .table-alarm{
                width: 100% !important;
            }

            .map, .table-stations, .table-sensors, .table-alarm{
                border: 1px solid;
                border-color: #DFE0EB;
                box-shadow: 1px 4px 4px rgba(0, 0, 0, 0.25);
                border-radius: 10px;
                padding: 5px;
            }
            
            @media only screen and (max-width: 768px){
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                & > .card-summary{
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    justify-content: space-between;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }

                & > .table-stations, .table-sensors, .table-alarm{
                    width: 100%;
                    justify-content: center;
                }
            }

            @media only screen and (max-width: 450px){
                width: 100%;
                & > .card-summary{
                    width: 100%;
                    justify-content: space-between;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }

                & > .table-stations, .table-sensors, .table-alarm{
                    width: 100%;
                    justify-content: center;
                }
            }
            
            @media only screen and (min-width: 1200px){
                & > .card-summary{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content:  center;
                    align-content: center;

                    & > * {
                        margin: 10px 0px;
                    }
                }
            }
        }
    }
`;

export default function Index(props) {
    const [perStation, setPerStation] = useState('')
    const [perSensor, setPerSensor] = useState('')
    const [sensorDataAlarmPermission, setSensorDataAlarmPermission] = useState('')
    const [data, setData] = useState([])
    const [mapData, setMapData] = useState([])

    const [dataListAllStation, setDataListAllStation] = useState([])
    const [dataListAllSensor, setDataListAllSensor] = useState([])
    const [dataListAllSensorAlarm, setDataListAllSensorAlarm] = useState([])

    const [content, setContent] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.master.setPath("/dashboard"))
        setContent(true)
        const init = async () => {
            let sensorDataAlarmPermission = await AuthService.permission('mgt-sensor-data-alarm')
            if(sensorDataAlarmPermission) setSensorDataAlarmPermission(sensorDataAlarmPermission)
            let perStation = await AuthService.permission('mgt-station')
            if(perStation) setPerStation(perStation)
            let perSensor = await AuthService.permission('mgt-sensor')
            if(perSensor) setPerSensor(perSensor)


            let data = await ServiceMap.search()
            let dataListAllStation = await ServiceListAllStation.search()
            let dataListAllSensor = await ServiceListAllSensor.search()
            let dataListAllSensorAlarm = await ServiceSensorDataAlarm.search()
            if(data){
                let response = []
                data.map((item)=>{ 
                    if(!response.find(responseItem => responseItem.station_name == item.station_name )) {
                        response.push({
                            province_name: item.province_name,
                            station_id: item.station_id,
                            station_name: item.station_name, 
                            gps_lat: item.gps_lat, 
                            gps_long: item.gps_long, 
                            sensors: [] 
                        })
                    }
                        
                    let responseItem = response.find(responseItem => responseItem.station_name == item.station_name)
                    let sensor = {
                        sensor_id: item.sensor_id,
                        data_id: item.data_id,
                        name: item.sensor_disp_name,
                        type_name: item.sensor_type_disp_name,
                        parameter_disp_name: item.parameter_disp_name,
                        connection_status: item.connection_status,
                        disp_connection: item.disp_connection,
                        data_datetime: item.data_datetime,
                        proc_data: item.proc_data 
                    }
                    responseItem.sensors.push(sensor)
                })
                setData(data)
                setMapData(response)
                setDataListAllStation(dataListAllStation)
                setDataListAllSensor(dataListAllSensor)
                setDataListAllSensorAlarm(dataListAllSensorAlarm)
                setContent(true)
            }
        }
        init()
    }, [])

    return (
        <Section className={"section-dashboard" + (props.className ? props.className : "")}>
            <div className="container">
                {!content ? <LoadingContent />
                    :
                    <>
                        <div className="page-title">
                            <img src='/image/speedometer.png' alt="speed-meter"/>
                            <span>แดชบอร์ด</span>
                        </div>
                        <div className="row">
                            <div className="map">
                                <Map data={mapData}/>
                            </div>
                            <div className="card-summary">
                                <SummaryStation className="card-summary__station" data={dataListAllStation}/>
                                <SummarySensor className="card-summary__sensor" data={dataListAllSensor} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="table-stations">
                                <TableListAllStation data={dataListAllStation} per={perStation}/>
                            </div>
                            <div className="table-sensors">
                                <TableListAllSensor data={dataListAllSensor} per={perSensor}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="table-alarm">
                                <div className="page-title">
                                    <img src='/image/alarm.png' alt="alarm"/>
                                    <span>แจ้งเตือน</span>
                                </div>
                                <TableListAlarm className="table-list-alarm" data={dataListAllSensorAlarm} fncSetData={setDataListAllSensorAlarm} permission={sensorDataAlarmPermission}/>
                            </div>
                        </div>
                    </>
                }
            </div>
        </Section>
    )
}
